import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PositioningUserItemComponent } from './positioning-user-item.component';
import { FlexModule } from '@angular/flex-layout';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [PositioningUserItemComponent],
  exports: [PositioningUserItemComponent],
  imports: [
    CommonModule,
    FlexModule,
    MatIconModule,
    MatMenuModule,
    MatButtonModule,
  ],
})
export class PositioningUserItemModule {}
